module.exports = __webpack_public_path__ + "img/MANAGEDROTATIONALGRAZING.202e730b.svg";